import { IButton } from '@/types/shared';

export const THANK_YOU_TITLE = `ขอบคุณสำหรับข้อมูลของคุณ`;
export const THANK_YOU_DESCRIPTION_WITH_SALE = `เราได้รับข้อมูล<span>การลงทะเบียนของคุณเรียบร้อยแล้ว</span> <br/>ทางเราจะติดต่อกลับและให้คำแนะนำคุณในไม่ช้า <br/>ผ่านทาง <strong>ตรีเพชรอีซูซุเซลส์ : 02-079-9799</strong>`;
export const THANK_YOU_DESCRIPTION = `ทางเราได้รับข้อมูล<span>การลงทะเบียนของคุณเรียบร้อยแล้ว</span> <br /><span>ทางเราจะติดต่อกลับ</span><span>และให้คำแนะนำคุณ</span><span>ในไม่ช้า</span>`;
export const THANK_YOU_SELL_YOR_TRUCK_DESCRIPTION = `<p>เราได้รับข้อมูลของคุณเรียบร้อยแล้ว<span>ทาง Truck2Hand จะติดต่อกลับโดยเร็วที่สุด</span></p><p><span>หรือท่านสามารถ <strong>ติดต่อทีมงาน ได้ที่ <a href="tel:0644566166" target="_blank">0644566166</a></strong></strong></span></p>`;

export const AVAILABLE_TIME_OPTIONS: string[] = [
  'ทุกช่วงเวลา',
  '8:30 - 12:00',
  '12:00 - 13:00',
  '13:00 - 17:00',
];

export const THANKYOU_BUTTON: IButton = {
  label: 'ดูรายละเอียดเพิ่มเติม',
  url: '/',
  icon: 'home',
};
